import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import {
    reduxForm,
    submit,
    getFormInitialValues,
    initialize,
    hasSubmitSucceeded,
    isSubmitting,
    SubmissionError
} from 'redux-form';
import { compose, lifecycle } from 'recompose';
import { RaisedButton } from 'material-ui';
import _ from 'lodash';
import { CAMPAIGN_FORM_ID, STORE_KEYS } from '../../../constants';
import { RowSection } from '../../components/helpers';
import { handleServerError } from 'dash-front/actions/helpers';
import { getEntities, getQueries } from 'dash-front/selectors';
import { fetchCampaignById, updateCampaign } from 'dash-front/campaign/actions/campaigns';
import { mapData, defValidate } from './schema';
import CampaignForm from './CampaignForm';

const Scene = ({ dispatch }) => (
    <div className="wdp-container">
        <CampaignForm />
        <RowSection
            hideSplit
            style={{ marginBottom: 16 }}
            rightContent={<RaisedButton primary label={'Save'} onTouchTap={() => dispatch(submit(CAMPAIGN_FORM_ID))} />}
        />
    </div>
);
/**
 * This bullshit will be fixed.
 * Should do this due to the stepper.
 */
const onSubmit = (values, dispatch, self) => {
    const { syncErrors } = self;
    const errorKeys = Object.keys(syncErrors || {});
    if (errorKeys.length === 0) {
        const mappedData = mapData(values);
        return dispatch(updateCampaign(mappedData)).then(handleServerError);
    } else {
        console.log('Invalid in wizzard');
        throw new SubmissionError({ _error_: 'Check your rules' });
    }
};

const mapStateToProps = (state, { params: { campaignId } }) => {
    const campaign = _.get(getEntities(state)[STORE_KEYS.CAMPAIGNS], `[${campaignId}]`);
    const fetchRequest = getQueries(state)[STORE_KEYS.CAMPAIGNS];
    const fetchFinished = fetchRequest && fetchRequest.isFinished;
    return {
        campaign,
        fetchFinished,
        initialValues: getFormInitialValues(CAMPAIGN_FORM_ID)(state),
        submitSucceeded: hasSubmitSucceeded(CAMPAIGN_FORM_ID)(state),
        submitting: isSubmitting(CAMPAIGN_FORM_ID)(state)
    };
};

const EditEnhanced = compose(
    connect(mapStateToProps),
    lifecycle({
        componentDidMount() {
            const { campaignId } = this.props.params;
            const { dispatch } = this.props;
            dispatch(fetchCampaignById(campaignId));
        },
        componentWillReceiveProps({
            campaign,
            dispatch,
            fetchFinished,
            initialValues,
            submitSucceeded,
            params: { campaignId }
        }) {
            if (!initialValues && fetchFinished && campaign) {
                dispatch(initialize(CAMPAIGN_FORM_ID, campaign));
            }
            if (this.props.submitting && submitSucceeded) {
                browserHistory.push('/campaigns/view/' + campaignId);
            }
        }
    }),
    reduxForm({
        form: CAMPAIGN_FORM_ID,
        onSubmit,
        validate: defValidate
    })
)(Scene);

export default EditEnhanced;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/Edit.js
 **/